/**
 * 職務経歴（workHistory）を「画面表示用の文字列」に変換するユーティリティ
 *
 * - Mobile / Desktop 共通で使う表示整形ロジック
 */
export const buildWorkHistoryDisplayValues = (workHistory) => {
  if (!workHistory) return {};

  // 両方の値が存在する場合のみ表示
  const hasPeriodLabel =
    workHistory.periodLabel != null && workHistory.periodLabel !== "";
  const hasPeriodMonths =
    workHistory.periodMonths != null && workHistory.periodMonths !== "";
  const hasProjectScale =
    workHistory.projectScale !== null && workHistory.projectScale !== "";
  const hasTeamScale =
    workHistory.teamScale !== null && workHistory.teamScale !== "";

  return {
    period:
      hasPeriodLabel && hasPeriodMonths
        ? `${workHistory.periodLabel}（${workHistory.periodMonths}）`
        : "",

    name: workHistory.name ?? "",

    roles: workHistory.roles ?? "",

    scale:
      hasProjectScale && hasTeamScale
        ? `PJ:${workHistory.projectScale}人\nチーム:${workHistory.teamScale}人`
        : "",

    industry: Array.isArray(workHistory.industry)
      ? workHistory.industry.join("\n")
      : (workHistory.industry ?? ""),

    developmentMethods: workHistory.developmentMethods ?? "",

    workSections: Array.isArray(workHistory.workSections)
      ? workHistory.workSections
      : [],
    skillSections: Array.isArray(workHistory.skillSections)
      ? workHistory.skillSections
      : [],

    achievement: workHistory.achievement ?? "",
  };
};
